import { Capacitor } from "@capacitor/core";
import { resolveGamesOrigin } from "./gameStore.ts";

/**
 * Registers the service worker.
 *
 * Skipped when the automation bridge is driving the app: a cached shell makes audit and perf
 * runs measure a stale build, which is the worst possible failure mode for a quality gate.
 *
 * Skipped in the phone app too. Its files are already on the device, so the cache buys nothing
 * and costs the ability to ship an update: the worker would keep serving the build it first saw.
 */
export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  if (Capacitor.isNativePlatform()) return;
  if (location.protocol !== "https:" && location.hostname !== "localhost") return;
  if (new URLSearchParams(location.search).has("noSw")) return;

  window.addEventListener("load", () => {
    // Handed its API on the query string: a worker cannot read the build settings, and a second
    // product served from another origin must not cache against the first one's server.
    const where = `/sw.js?api=${encodeURIComponent(resolveGamesOrigin())}`;
    void navigator.serviceWorker.register(where).catch(() => {
      // A failed registration only costs offline support; the app still runs.
    });
  });
}
